module.exports = __webpack_public_path__ + "static/media/importICloud2.bbaeeb82.png";